
<template>
  <div class="complete_content">
    <dd-header
      :isMenuView='false'
    />
    <div class="container">
      <section>
        <div class="title">
          <h2>パスワード設定完了</h2>
        </div>
        <div class="main_content">
          <ul class="thanks">
            <li>パスワードを再設定しました。</li>
            <li>引き続きHAKOTANをご利用ください。</li>
          </ul>
          <div class="return_link"><a @click="goLogin">ログイン画面へ戻る</a></div>
        </div>
        <div class="login_form">
          <div class="logo">
            <div class="regist_form">
              <dd-login></dd-login>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>

import * as App from '../../utils/App'
import {DC_STORAGE_KEY} from '../../constants/App'
// Module
import Header from '../components/common/DcHeader'
import LoginForm from '../components/login/DcLoginForm'

export default {
  name: 'orderComplete',
  components: {
    'dd-header': Header,
    'dd-login': LoginForm
  },
  data () {
    return {
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    goLogin: function () {
      this.$router.push({
        name: 'DcLogin'
      })
    }
  },
  created () {
    App.removeLocalStorage(DC_STORAGE_KEY.TOP_FORM)
    App.removeLocalStorage(DC_STORAGE_KEY.PRICE_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
    App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
    App.removeLocalStorage(DC_STORAGE_KEY.SELECT_PLAN)
    App.removeLocalStorage(DC_STORAGE_KEY.PAYMENT_TYPE)

    App.removeLocalStorage(DC_STORAGE_KEY.PREF_RESEARCH)
    App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_CHECKED)
    App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_DATA)
  }

}
</script>
<style src="../css/dc-login.scss" lang="scss" scoped></style>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcPasswordResetComplete.vue